/*
 * @Author: Scherger
 * @Date: 2019-02-19 10:07:44
 * @Last Modified by: Scherger
 * @Last Modified time: 2019-10-23 10:35:07
 */

import goFun from "@/utils/cc-webapp/navigator.js";
import loginjs from "@/utils/cc-webapp/login.js";
import utilsFun from "@/utils/utils.js";
import {
  CONFIG,SERVER
} from "@/api/apiConfig.js";
import requestFun from "@/utils/cc-webapp/request.js";
import Vue from "vue";

import TOAST from "@/utils/vant.js";


//系统  Android or iOS
const APP_SYSTEM = (() => {
  var system = 'h5'
  try {
    system = JSON.parse(native.getDeviceInfo()).system
  } catch (error) {

  }

  return system
})()

//是否为Native环境
var isNative = utilsFun.chackNative()

// this.$router 路由
var vueRoute = ''



/** 获取静默登录信息
 *
 * @param  {string} checkUserType 默认不校验，存在内容则校验内容，不成功则返回错误
 *
 * @param  {string} isJump 是否跳转。存在内容或为true是不跳转， 默认不填或为false 则为跳转（为了语义可填入 'no login'，便于区分）
 *
 * @Example
 *  当前只有ios有静默登录
 *  安卓用户默认成功返回
 *
 * @Example
 *    静默登录为开启时有session成功返回
 *    静默登录为开启，本地没有session时 请求匿名session 并成功返回
 *
 * @Example
 *    静默登录为关闭时返回错误
 *    静默登录为关闭时并且本地有session时，清空本地session
 *
 * @returns {String}  成功时返回 isAndorid、 haveAnonymousOrSession
 *
 * @returns {String}  错误时返回 noneAnonymous checkFalse
 *
 */
function checkSilent(checkUserType, isJump) {

  var gotoPage = {
    path: utilsFun.splitUrl('login'),
    isTransWindows: true
  }

  return new Promise((resolve, reject) => {

    if (APP_SYSTEM == "Android") {
      resolve('isAndorid')
      return
    }

    return requestFun.doAxios(CONFIG.USER.ANONYMOUS, {}, "GET").then(anonymousResult => {

        let flag = anonymousResult.data //1 开启   0关闭
        console.log('flag', flag);

        getSession('no login').then(sessionResult => {
          console.log('sessionResult', sessionResult);

          //存在session
          if (flag == 0) {
            //关闭状态检查本地session是否为游客，
            //是则清除本地session返回错误，
            //不是则返回成功
            if (sessionResult.userType == 'visitor') {
              // alert('login2 checkSilent')
              TOAST.text("匿名已過期，請退出重新登錄");
              localStorage.removeItem('app_session');

              if (!isJump) {
                goFun.openTo(gotoPage)
              }

              reject('noneAnonymous')

            } else {

              if (!checkUserType) { //傳入了false
                resolve('haveAnonymousOrSession')
              } else {
                if (sessionResult.userType != checkUserType) {
                  // console.log(111111)
                  if (!isJump) {
                    goFun.openTo(gotoPage)
                  }
                  reject('checkFalse')

                } else {
                  resolve('haveAnonymousOrSession')
                }


              }


            }

          } else {
            //开启状态检查先是否存在判断用户类型
            //若存在且不想等则返回错误 ，相等则返回成功
            //若不存在则返回成功
            if (checkUserType) {

              if (sessionResult.userType != checkUserType) {

                if (!isJump) {
                  goFun.openTo(gotoPage)
                }
                reject('checkFalse')

              } else {
                resolve('haveAnonymousOrSession')
              }

            } else {
              resolve('haveAnonymousOrSession')
            }

          }

        }).catch(() => {
          //没有session的时候,并且为开启状态请求匿名session

          if (flag == 1) {

            requestFun.doAxios(CONFIG.USER.LOGINBYDEVICEID, {}, "GET").then(res => {

              _setSessionCache(res.data).then(() => {
                //请求成功后返回成功状态
                resolve('newAnonymous')
              })


            }).catch(err => {
              //请求错误则统一返回 noneAnonymous
              if (!isJump) {
                goFun.openTo(gotoPage)
              }

              reject('noneAnonymous')
            });


          } else {

            if (!isJump) {
              goFun.openTo(gotoPage)
            }

            reject('noneAnonymous')
          }

        })

      })
      .catch(err => {
        //请求错误则统一返回 noneAnonymous
        if (!isJump) {
          goFun.openTo(gotoPage)
        }
        reject('noneAnonymous')
      });

  })

}


/** 獲取session
 *  @param  {string} isJump 是否跳转。存在内容或为true是不跳转， 默认不填或为false 则为跳转（为了语义可填入 'no login'，便于区分）
 *
 */
function getSession(isJump) {

  return new Promise((resolve, reject) => {
    if (SERVER.DEV) {
      resolve({
        session: loginjs.w_session,
      })
      return
    }

    return _getSessionCache().then(session => {

      let sessionData = JSON.parse(session)
      return _checkSession(sessionData, isJump).then(resSession => {
        return resolve(resSession)
      }).catch(err => {
        //没有session
        //检查是否需要跳转首页
        // console.log(222)
        if (!isJump) {
          let obj = {
            path: utilsFun.splitUrl('login'),
            isTransWindows: true
          }
        }
        return reject('no session')

      })

    }).catch(() => {
      //检查是否需要跳转首页
      if (!isJump) {
        let obj = {
          path: utilsFun.splitUrl('login'),
          isTransWindows: true
        }
        goFun.openTo(obj)
      }
      return reject('no session')
    })


  })

}


//退出登錄
function signOut() {
  // native.showToast("正在退出當前帳號！");
  // alert('login2 signOut')
  localStorage.removeItem('app_session');
  localStorage.removeItem('audioPlayrecord');
  TOAST.text("成功退出當前帳號！");

  //native.hidePlayBar();


  setTimeout(() => {
    let obj = {
      backPage: 'setting'
    }
    goFun.closeW(obj)

  }, 3500);

}


/** 设置页面router
 * @param  {Object} pageRouter 传入的页面 路由   this.$router
 */
function setRouter(pageRouter) {
  vueRoute = pageRouter
}


/** 第三方登录
 * @param  {Object} result 客户端回调信息
 */
function doThirdLogin(result) {

  let postD = {
    data: result
  };

  requestFun.doAxios(CONFIG.USER.THIRDLOGIN, postD, "POST")
    .then(res => {

      if (isNative) {
        native.hideLoading();
      }

      if (res.data) {

        _checkUserInfo(res.data)

      } else {
        TOAST.text("數據出錯，請稍候再試");
      }

    })
    .catch(err => {
      if (isNative) {
        native.hideLoading();
      }
      let res = err.response;
      TOAST.text("失敗:" + res.data.message);
    });

}

/** 手机登录
 * @param  {Object} postData 上传数据(修改)
 */
function doPhoneLogin(postData) {

  if (isNative) {
    native.showLoading();
  }

  //提交接口执行登入
  requestFun.doAxios(CONFIG.USER.TELLOGIN, postData, "GET")
    .then(res => {

      if (isNative) {
        native.hideLoading();
      }

      if (res.data) {

        _checkUserInfo(res.data, 'phone')

      } else {
        TOAST.text("數據出錯，請稍候再試");
      }
    })
    .catch(err => {
      // console.log(err);

      if (isNative) {
        native.hideLoading();
      }

      let res = err.response;
      native.showToast("登入失败:" + res.data.message);
    });

}

/** 邮箱登录
 * @param  {Object} postData 上传数据
 */
function doEmailLogin(postData) {

  if (isNative) {
    native.showLoading();
  }

  //提交接口执行登入
  requestFun.doAxios(CONFIG.USER.LOGIN, postData, "GET")
    .then(res => {
      if (isNative) {
        native.hideLoading();
      }

      _checkUserInfo(res.data, 'email')

    })
    .catch(err => {
      if (isNative) {
        native.hideLoading();
      }
      let res = err.response;
      TOAST.text("登入失败:" + res.data.message);
    });

}

/**
 * -------------------
 *     内部私有方法
 * -------------------
 */

/** 检查sessions是否过期
 * @param  {Object} sessionData session数据
 *
 * @param  {Object} isJump 是否跳转
 */
function _checkSession(sessionData, isJump) {

  let url = utilsFun.splitUrl('login')
  var GotoData = {
    path: url,
    params: {},
    isTransWindows: true
  };

  //console.log('run _checkSession', sessionData);
  return new Promise((resolve, reject) => {

    let etime = sessionData.expireAt
    let toDayTime = Date.now()

    let m1 = new Date(toDayTime + 2592000000).getTime() //30天 （1个月）
    let m2 = new Date(toDayTime + 5184000000).getTime() //60天 （2个月）

    //console.log('run this _checkSesion', toDayTime, etime, m1, m2);
    // if (m1 < etime && etime < m2)/
    if (m1 < etime && etime < m2) {
      console.log('大于1个月并且小于两个月，更新session');

      requestFun.doSessionAxios(CONFIG.USER.REFRESHSESSION, {}, "POST", false, sessionData).then(res => {
        // console.log('run 222');
        console.log('login2 _checkSession授权已過期，請退出重新登錄')
        utilsFun.showToast("Session授权已過期，請退出重新登錄");
        localStorage.removeItem('app_session');

        _setSessionCache(res.data);

        let returnSession = res.data.session
        returnSession['clientType'] = APP_SYSTEM

        resolve(returnSession)

      }).catch(err => {
        //console.log('run 333');

        //更新session错误
        // console.log(err);
        resolve(sessionData)
      })

    } else if (toDayTime < etime) {
      console.log('Session未过期')
      // console.log('run 444');
      resolve(sessionData)

    } else {
      console.log('Session过期');
      TOAST.text("已過期請退出重新登錄");
      localStorage.removeItem('app_session');

      reject('session 过期')

    }


  })


}



/** 检查用户信息
 * @param  {Object} userData 后台返回的用户session
 * @param  {String} loginType  登入類型默認爲第三方登入
 */
function _checkUserInfo(userData, loginType) {

  if (userData.userInfo.email == null && !loginType) {
    //拿邮箱判断新老用户
    //新用户
    let obj = {};
    obj["path"] = "/app/bindEmail";
    obj["query"] = {
      getPage: true,
      session: userData.session
    };

    native.showToast("授權成功，需要綁定電郵，即將跳轉");

    setTimeout(() => {
      goFun.navigateTo(vueRoute, obj);
    }, 1500);

  } else if (userData.userInfo.isNew == 1) {
    //新用户

    _setSessionCache(userData);

    let obj = {};
    obj["path"] = "/app/registerSuccess";

    let showText = '授權成功，即將跳转'
    if (loginType && loginType == 'phone' || loginType == 'email') {
      showText = '登入成功，即將跳转'
    }

    native.showToast(showText);

    setTimeout(() => {
      goFun.navigateTo(vueRoute, obj);
    }, 1500);

  } else {
    //老用戶

    _setSessionCache(userData);

    //更新評論權限
    requestFun.doSessionAxios(
        CONFIG.COMMENT.CHECK, {},
        "GET",
        "no login",
        userData.session
      )
      .then(commentRes => {

        let showText = '授權成功，即將跳转'
        if (loginType && loginType == 'phone' || loginType == 'email') {
          showText = '登入成功，即將跳转'
        }

        native.showToast(showText);

        Vue.prototype.COMMENTFLAG = commentRes.data;

        setTimeout(() => {
          goFun.closeW(JSON.stringify({
            test: "test"
          }));
        }, 1500);
      })
      .catch(err => {});
  }

}


/** 将session存储到本地中 (异步)
 * @param  {String} sessionData 接口返回的data数据
 */
function _setSessionCache(sessionData) {

  let obj = sessionData
  obj['clientType'] = APP_SYSTEM

  if (sessionData.userInfo) {
    obj['userInfo'] = sessionData.userInfo
  }

  return new Promise((resolve, reject) => {
    // var setData = {
    //   key: 'app_session',
    //   value: JSON.stringify(obj)
    // };
    // native.setStorage(JSON.stringify(setData));

    // localStorage.setItem('app_session', JSON.stringify(obj));
    loginjs.saveLoginSession(obj);

    resolve(obj)
  })
}

/** 从本地缓存中同步获取session
 * @returns 返回缓存的登录数据，无则返回 false
 */
function _getSessionCache() {
  return new Promise((resolve, reject) => {
    var dataValue = localStorage.getItem('app_session');
    if (dataValue) {
      resolve(dataValue)
    } else {
      reject()
    }
  })

}

function getThirdPartToken() {
  return localStorage.getItem('thirdPartToken');
}
function setThirdPartToken(thirdPartToken) {
  localStorage.setItem('thirdPartToken',thirdPartToken);
}



export default {
  doThirdLogin,
  setRouter,
  doPhoneLogin,
  doEmailLogin,
  signOut,
  getSession,
  checkSilent,
  getThirdPartToken,
  setThirdPartToken,
  _setSessionCache
}



// WEBPACK FOOTER //
// ./src/utils/cc-webapp/login2.js